import React from 'react'

import { IconProps } from '../../../../types'
import IconWrapper from '../../../IconWrapper'

const ActionValidIconMedium: React.FC<IconProps> = (props) => (
  <IconWrapper {...props}>
    <path
      fillRule="evenodd"
      d="m16.973 8.969-5.97 5.97-3.473-3.472-1.06 1.06 4.533 4.534 7.031-7.032-1.06-1.06Z M19.071 19.071A10 10 0 1 1 4.93 4.928 10 10 0 0 1 19.07 19.071Zm-1.06-1.06A8.5 8.5 0 1 1 5.99 5.99a8.5 8.5 0 0 1 12.02 12.02Z"
    />
  </IconWrapper>
)

export default ActionValidIconMedium
